import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d4085ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "tenvanban",
  style: {"font-weight":"bold","width":"50vw"}
}, "Tên văn bản :", -1))
const _hoisted_5 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Nội dung:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-sm-12 p-md-12" }, null, -1))
const _hoisted_8 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_9 = { class: "p-field p-col-2 p-sm-2 p-md-2" }
const _hoisted_10 = { enctype: "multipart/form-data" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_13 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_14 = { id: "adding" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đang gởi văn bản, vui lòng chờ...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    style: {"text-align":"center"},
    header: "Thêm văn bản"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              id: "tenvanban",
              type: "phone",
              modelValue: $setup.vanBanCreate.tenVanBan,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.vanBanCreate.tenVanBan) = $event)),
              style: {"width":"50vw"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createVNode(_component_Textarea, {
                id: "noidung",
                type: "phone",
                modelValue: $setup.vanBanCreate.noiDungVanBan,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.vanBanCreate.noiDungVanBan) = $event)),
                rows: "20"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              class: "p-button-outlined",
              label: "Đính kèm tập tin",
              onclick: "document.getElementById('myFile').click()",
              icon: "pi pi-paperclip",
              style: {"margin-right":"2vw","width":"15vw"}
            }),
            _createVNode(_component_Button, {
              label: "Gởi văn bản",
              type: "button",
              icon: "pi pi-send",
              align: "center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.upload())),
              disabled: $setup.loadingBar||!$setup.valid(),
              style: {"width":"15vw"}
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("form", _hoisted_10, [
              _createElementVNode("input", {
                id: "myFile",
                type: "file",
                style: {"display":"none"},
                accept: ".xls,.xlsx,.doc,.docx,.pdf",
                name: "files",
                multiple: "multiple",
                onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.fileChange($event.target.files))),
                disabled: $setup.loadingBar
              }, null, 40, _hoisted_11)
            ])
          ])
        ]),
        ($setup.listFileName.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_DataTable, {
                value: $setup.listFileName,
                showGridlines: "",
                responsiveLayout: "scroll",
                style: {"font-size":"13px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "nameFile",
                    header: "Tập tin"
                  }),
                  _createVNode(_component_Column, {
                    field: "",
                    header: "",
                    style: {"width":"20px"}
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Dialog, {
            header: "Gởi đề tài",
            visible: $setup.loadingBar,
            "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.loadingBar) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_ProgressBar, {
                  mode: "indeterminate",
                  style: {"height":".3em"}
                })
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_ConfirmDialog)
        ])
      ])
    ]),
    _: 1
  }))
}